import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import PracticeInfoForm from 'pages/Dashboard/components/PracticeInfoForm';
import PatientInfoForm from 'pages/Dashboard/components/PatientInfoForm';
import {
  PatientDemographicFormConsent,
  PatientInviteFormConsent,
  SMSConsent,
} from 'pages/Dashboard/components/AddPatientConsents';
import { PatientForm } from 'pages/Dashboard/types';
import { CircularProgress, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Toast, { ToastProps } from 'components/Common/Toast';

interface IProps {
  onSubmit: SubmitHandler<PatientForm>;
  patientFormDemographic: boolean;
  addPatientWithoutInvite: boolean;
  setPatientFormDemographic: (val: boolean) => void;
  isLoading: boolean;
  setIsMinor?: (isMinor: boolean) => void;
  onSuccess?: (value: React.SetStateAction<boolean>) => void;
}

export default function AddNewPatientForm({
  onSubmit,
  patientFormDemographic,
  addPatientWithoutInvite,
  setPatientFormDemographic,
  isLoading,
  setIsMinor,
  onSuccess,
}: IProps) {
  const { handleSubmit, watch, formState } = useFormContext();
  const [uploadToastProps, setUploadToastProps] = React.useState<ToastProps | null>(null);
  const mobile = watch('mobile');

  function getButtonContent() {
    if (isLoading) {
      return <CircularProgress color='primary' size={30} />;
    }
    return (
      <Typography variant='h6'>
        {addPatientWithoutInvite && patientFormDemographic && !mobile
          ? 'Add patient'
          : 'Send invite'}
      </Typography>
    );
  }

  return (
    <>
      {uploadToastProps && (
      <Toast
        {...uploadToastProps}
        onClose={() => setUploadToastProps(null)}
      />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <PracticeInfoForm />
          </Grid>
          <Grid item>
            <PatientInfoForm
              isDemographicForm={patientFormDemographic}
              addPatientWithoutInvite={addPatientWithoutInvite}
              setIsDemographicForm={setPatientFormDemographic}
              setIsMinor={setIsMinor}
              onSuccess={onSuccess}
              setUploadToastProps={setUploadToastProps}
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 6, mb: 2 }}>
          <Button
            color='success'
            variant='contained'
            type='submit'
            size='large'
            disabled={
            isLoading
            || formState.isSubmitting
            || (formState.isSubmitSuccessful && !formState.isDirty)
          }
            sx={{ width: 300 }}
            startIcon={<SendIcon />}
          >
            {getButtonContent()}
          </Button>
        </Box>
        {!patientFormDemographic && <SMSConsent />}
        <Box mt={2}>
          {patientFormDemographic ? <PatientDemographicFormConsent />
            : <PatientInviteFormConsent />}
        </Box>
      </form>
    </>
  );
}
